<template>
  <svg class="icon icon--interactive" wclassth="64px" height="74px" viewBox="0 0 64 74" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g class="Page-1" stroke="none" stroke-wclassth="1" fill="none" fill-rule="evenodd">
      <g class="02_Home_d" transform="translate(-780.000000, -390.000000)">
        <g class="Icon-Interactive" transform="translate(782.000000, 390.000000)">
          <path d="M1.38666667,3 L59,3" class="Line" stroke="#FFFFFF" stroke-wclassth="2" stroke-linecap="square"></path>
          <path d="M14,36 C14,44.836556 21.3873016,52 30.5,52 L30.5,52 C39.6126984,52 47,44.836556 47,36" class="Oval-2" stroke="#FFFFFF" stroke-wclassth="2"></path>
          <circle class="Oval-3" fill="#FFFFFF" cx="39.5" cy="18.5" r="2.5"></circle>
          <circle class="Oval-3-Copy" fill="#FFFFFF" cx="15.5" cy="2.5" r="2.5"></circle>
          <path d="M1.38666667,19 L59,19" class="Line-Copy" stroke="#FFFFFF" stroke-wclassth="2" stroke-linecap="square"></path>
          <path d="M1.38666667,35 L59,35" class="Line-Copy-2" stroke="#FFFFFF" stroke-wclassth="2" stroke-linecap="square"></path>
          <path d="M30,73 L30,61.789481" class="Line-Copy-3" stroke="#FFFFFF" stroke-wclassth="2" stroke-linecap="square"></path>
          <path d="M49,66 L44,58" class="Line-Copy-4" stroke="#FFFFFF" stroke-wclassth="2" stroke-linecap="square"></path>
          <path d="M60,55 L52,50" class="Line-Copy-5" stroke="#FFFFFF" stroke-wclassth="2" stroke-linecap="square"></path>
          <path d="M0,54.2857143 L8,50" class="Line-Copy-6" stroke="#FFFFFF" stroke-wclassth="2" stroke-linecap="square"></path>
          <path d="M12,66 L17,58" class="Line-Copy-7" stroke="#FFFFFF" stroke-wclassth="2" stroke-linecap="square"></path>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return{}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/Interactive.vue